var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app-vue","dir":"ltr"}},[_c('FlyoutWrapper',{attrs:{"country":_vm.computedCountry,"language":_vm.computedLanguage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }